module.exports = __webpack_public_path__ + "static/media/shift_management.6442830d.webp";